'use strict'

import { Enum } from './enums'

const UserStatusEnum = new Enum({
  CANCELLED: { value: 0, summaryCN: '已注销', summaryEN: 'cancelled' },
  AVAILABLE: { value: 1, summaryCN: '启用', summaryEN: 'available' },
  DISABLE: { value: 2, summaryCN: '停用', summaryEN: 'disable' }
})

export { UserStatusEnum }



// WEBPACK FOOTER //
// ./src/utils/UserStatusEnum.js